// extracted by mini-css-extract-plugin
export default {"card":"PerformanceOverTime_card__24Mb1","cardHeading":"PerformanceOverTime_cardHeading__Cctul"};